export default __webpack_public_path__ + "media/titles/title_6_locale_fr-95f8cb27.png";